"use client";
import { Fragment, jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ModalBase/NativeScrollArea.tsx
function NativeScrollArea({ children }) {
	return /* @__PURE__ */ jsx(Fragment, { children });
}
//#endregion
export { NativeScrollArea };

//# sourceMappingURL=NativeScrollArea.mjs.map